import { render, staticRenderFns } from "./FLightweightCharts.vue?vue&type=template&id=20752e47&"
import script from "./FLightweightCharts.vue?vue&type=script&lang=js&"
export * from "./FLightweightCharts.vue?vue&type=script&lang=js&"
import style0 from "./FLightweightCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports